import { Stack } from '@jarvis/web-stratus-client'
import * as ContentStack from 'contentstack'

import { CONTENT_STACK_CREDENTIALS } from '@/constants/content-stack'

export function createCMSClient(stack: Stack) {
  const { environment, deliveryToken } =
    CONTENT_STACK_CREDENTIALS[
      stack as Exclude<
        // There is no config for dev environment
        Stack,
        Stack.dev
      >
    ]

  return ContentStack.Stack({
    api_key: CONTENT_STACK_CREDENTIALS.apiKey,
    delivery_token: deliveryToken,
    environment,
  })
}
